import { useEffect, useState } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

export default function PWAUpdatePrompt() {
  const [show, setShow] = useState(false)
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered() {},
    onRegisterError(e) { console.error('[pwa] sw register error', e) },
  })

  useEffect(() => { setShow(needRefresh || offlineReady) }, [needRefresh, offlineReady])

  if (!show) return null

  return (
    <div className="fixed bottom-24 md:bottom-6 left-1/2 -translate-x-1/2 z-40 border border-[var(--accent)]/40 rounded-md px-4 py-3 flex items-center gap-3 animate-system-open"
         style={{ background: 'var(--bg)' }}>
      <span className="text-sm">
        {needRefresh ? 'Neue Version verfügbar.' : 'Offline bereit.'}
      </span>
      {needRefresh && (
        <button onClick={() => updateServiceWorker(true)} className="px-3 py-1 rounded bg-[var(--accent)] text-black font-semibold text-xs">
          Reload
        </button>
      )}
      <button onClick={() => { setNeedRefresh(false); setOfflineReady(false); setShow(false) }}
              className="text-xs opacity-60 hover:opacity-100">×</button>
    </div>
  )
}
